import axios from "./axiosAuthRequired"
import { isEmpty } from "lodash"
const uuidv4 = require("uuid/v4")

// TODO: Move "global" storage of access tokens into singleton Axios instance configuration
export const getAuthHeaders = () => {
  let headers = {}
  let clientCredentials = window.localStorage.getItem("client_credentials")
  if (!isEmpty(clientCredentials)) {
    headers["Authorization"] = "Bearer " + clientCredentials
  }

  return headers
}

export const refreshClientCredentials = () => {
  let refreshToken = window.localStorage.getItem("refresh_token")

  let url = process.env.PROGUIDES_WEB_URL + "api/v2/tokens/"

  let body = new FormData()
  body.append("grant_type", "refresh_token")
  body.append("refresh_token", refreshToken)

  return axios({
    method: "post",
    url: url,
    data: body,
  })
    .then(response => {
      // set local storage with user tokens
      if (response.data) {
        if (response.data.access_token) {
          window.localStorage.setItem(
            "client_credentials",
            response.data.access_token
          )
        }
        if (response.data.refresh_token) {
          window.localStorage.setItem(
            "refresh_token",
            response.data.refresh_token
          )
        }
      }
      return response
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const clearStoredAccessTokens = () => {
  window.localStorage.removeItem("client_credentials")
  window.localStorage.removeItem("refresh_token")
}

export const apiLogin = (email, password, rememberMe) => {
  let encoded = email + ":" + password
  encoded = btoa(encoded)
  let headers = {
    Authorization: "Basic " + encoded,
  }
  let body = new FormData()
  body.append("grant_type", "client_credentials")
  if (rememberMe) {
    let deviceName = "web-" + uuidv4()
    body.append("new_device_name", deviceName)
  }
  let url = process.env.PROGUIDES_WEB_URL + "api/v2/tokens/"
  return axios({
    method: "post",
    url: url,
    data: body,
    headers: headers,
  })
    .then(response => {
      if (response.data) {
        let clientCredentials = response.data.access_token
        window.localStorage.setItem("client_credentials", clientCredentials)
        if (rememberMe) {
          let refreshToken = response.data.refresh_token
          window.localStorage.setItem("refresh_token", refreshToken)
        }
        return response.data
      }
      return response
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

export const oauthLogin = async (provider, token) => {
  let url = process.env.PROGUIDES_WEB_URL + "api/v2/tokens/"
  let body = new FormData()
  body.append("grant_type", "oauth_provider")
  body.append("provider", provider)
  body.append("provider_token", token)
  let deviceName = "web-" + uuidv4()
  body.append("new_device_name", deviceName)
  try {
    const res = await axios.post(url, body)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const checkAuthStatus = async () => {
  const url = `${process.env.PROGUIDES_WEB_URL}api/v2/user/account/oauth-providers`
  const clientCredentials = localStorage.getItem("client_credentials")
  const config = {
    headers: {
      Authorization: "Bearer " + clientCredentials,
    },
  }
  try {
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const disconnectOauth = async body => {
  const url = `${process.env.PROGUIDES_WEB_URL}api/v2/user/account/oauth-providers/disconnect`
  const clientCredentials = localStorage.getItem("client_credentials")
  const config = {
    headers: {
      Authorization: "Bearer " + clientCredentials,
    },
  }
  try {
    const res = await axios.put(url, body, config)
    return res.data
  } catch (error) {
    console.error(error)
    return error.response.data
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js